// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"476046c6","842":"054bd8a0"}[chunkId] + ".chunk.css";
};